"use client";

import { useEffect } from "react";

/**
 * Global error handler to suppress benign console errors that don't affect functionality.
 * Currently suppresses CORS errors from Twitter video embeds which are expected and harmless.
 */
export function GlobalErrorHandler() {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      // Suppress CORS errors from Twitter video embeds
      // These are expected since we're embedding Twitter videos without proxy
      if (
        event.message &&
        (event.message.includes("video.twimg.com") ||
          (event.message.includes("CORS") &&
            event.message.includes("Access-Control-Allow-Origin")))
      ) {
        event.preventDefault();
        return true;
      }
      return false;
    };

    window.addEventListener("error", handleError, true);

    return () => {
      window.removeEventListener("error", handleError, true);
    };
  }, []);

  return null;
}
